<template>
    <div class="au-lang" role="group" :aria-label="$t('nav.language')">
        <i class="bi bi-translate"></i>
        <button v-for="code in locales" :key="code" type="button" :class="{ 'is-active': code === $i18n.locale }"
            :aria-pressed="code === $i18n.locale" @click="change(code)">
            {{ code.toUpperCase() }}
        </button>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { availableLocales, AppLocale } from "@/locales";
import { setLocale } from "@/helpers/i18n";

export default defineComponent({
    name: "LanguageSwitch",
    data() {
        return {
            locales: availableLocales,
        };
    },
    methods: {
        change(code: AppLocale) {
            setLocale(code);
        },
    },
});
</script>
